export enum TLogLevelsIndexedDB {
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
  DEBUG = 'debug',
  CRITICAL = 'critical',
  SUCCESS = 'success',
  FATAL = 'fatal',
  TRACE = 'trace',
}
